import { storecfg } from './appkitStore'
import { getAccount } from '@wagmi/core'
import { wagmiAdapter } from './appKit'

export const initializeSubscribers = (modal) => {
	const syncCurrentChain = (chainId) => {
		const normalizedChainId = Number(chainId)
		if (![1, 56].includes(normalizedChainId)) return

		localStorage.setItem('cur_chainId', String(normalizedChainId))
	}

	const connectedWalletChainId = () => Number(getAccount(wagmiAdapter.wagmiConfig).chainId)

	modal.subscribeAccount((state) => {
		syncCurrentChain(connectedWalletChainId() || (state && state.chainId) || modal.getChainId())
	})

	modal.subscribeNetwork(state => {
		syncCurrentChain(connectedWalletChainId() || (state && state.chainId))
	})

	modal.subscribeState(state => {
		storecfg.appKitState = state
	})

}
